var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg48IconDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#f4f3f0",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-205.917 -2704.535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.3,11.577A1.3,1.3,0,0,1-.859,9.691,28.974,28.974,0,0,1,3.8,3.165,21.074,21.074,0,0,1,9.927-.9a1.3,1.3,0,1,1,.98,2.4A18.711,18.711,0,0,0,5.621,5.012a26.63,26.63,0,0,0-4.168,5.857A1.3,1.3,0,0,1,.3,11.577Z",
    transform: "translate(229.62 2729.304)",
    fill: "#816920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.3,31.565a1.3,1.3,0,0,1-1.3-1.3V9.163a1.3,1.3,0,0,1,2.594,0v21.1A1.3,1.3,0,0,1,.3,31.565Z",
    transform: "translate(229.62 2708.322)",
    fill: "#816920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.418,11.577a1.3,1.3,0,0,1-1.156-.708h0A26.753,26.753,0,0,0,5.093,5.012,18.548,18.548,0,0,0-.193,1.5,1.3,1.3,0,1,1,.787-.9,21.074,21.074,0,0,1,6.915,3.165a28.974,28.974,0,0,1,4.658,6.526,1.3,1.3,0,0,1-1.155,1.886Z",
    transform: "translate(219.5 2729.304)",
    fill: "#816920"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg48IconDown);
export default __webpack_public_path__ + "static/media/48-icon-down.4fda0257.svg";
export { ForwardRef as ReactComponent };